import {
   Component,
   ViewChild,
   ViewContainerRef,
   Input,
   ComponentFactoryResolver,
   OnInit,
   OnDestroy,
   AfterViewInit,
   EventEmitter,
   Output,
   ContentChildren,
   QueryList,
   AfterContentInit,
   ContentChild,
   ChangeDetectorRef,
   Injector,
} from '@angular/core';

import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

import { Subject, Subscription } from 'rxjs';
import { AcoesService, GridService, MessageService, NavigationService, PresenterService } from 'kmm-corp-api';
import { KmmNgBackendService } from 'kmm-ng-backend';

import { GridColumnComponent, GridTemplate, GridDataSourceComponent } from '../grid-column.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ModeloGridListaComponent } from '../modelo-grid/lista/modelo-grid.lista';
import { DynamicFilterComponent } from '../dynamic-filter/component/dynamic-filter.component';

export class DataService {
   context: any;
   function: any;
}

export class GridCalculateCellValue {
   dataField: string;
   calculate: any;
}

export class GridDataSource {
   contextName: string;
   module?: string;
   operation?: string;
   params?: any = {};
   service?: DataService;
   calculateDisplayValues?: Array<any>;
   calculateCellValues?: Array<GridCalculateCellValue>;
   filter?: DataSourceFilter;
}

export class DataSourceFilter {
   operation: string;
   module: string;
}

@Component({
   selector: 'app-dynamic-grid-component',
   templateUrl: './dynamic-grid.component.html',
   styleUrls: ['./dynamic-grid.component.scss']
})
export class DynamicGridComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {

   @ViewChild('customComponentsContainer', { static: true, read: ViewContainerRef }) customComponentsContainer: ViewContainerRef;
   @ViewChild('dxDataGrid', { static: true, read: DxDataGridComponent }) dxDataGrid: DxDataGridComponent;
   @ViewChild('popupsContainer', { static: true, read: ViewContainerRef }) popupsContainer: ViewContainerRef;
   @ViewChild('modeloGridLista', { static: true, read: ModeloGridListaComponent }) modeloGridLista: ModeloGridListaComponent;
   @ViewChild('dynamicFilter', { static: true, }) dynamicFilter: DynamicFilterComponent;

   @ContentChild(GridTemplate, { static: true, }) gridTemplate: GridTemplate;
   @ContentChild(GridDataSourceComponent, { static: true, }) gridDataSource: GridDataSourceComponent;
   @ContentChildren(GridColumnComponent) gridColumns: QueryList<GridColumnComponent>;

   @Input() contextName?: string = '';
   @Input() height: string;
   @Input() width: string;
   @Input() popup: boolean = false;
   @Input() keyExpr: string = '';
   @Input() selectionMode: string = 'none';

   /**
    * NÃ£o excluir
    */
   @Input() dataSource: any;
   @Input() pageSize: number = 20;
   @Input() showPageSize = true;
   @Input() summaries: any;
   @Input() summaryItems: any;
   @Input() masterDetail: any;
   @Input() rowAlternationEnabled: boolean = true;
   @Input() calculateSummary: Function;

   private _toolbar: any;

   columns: any = [];
   customColumns: any[];
   cCols: any = [];

   factory: any = [];
   componentRef: any = [];
   componentInstance: any = [];

   popupComponents: Array<any>;
   popupFactory: any = [];
   popupComponentRef: any = [];
   popupComponentInstance: any = [];

   onRefresh: Subject<any>;

   onOpenInsert: Subject<any>;
   onOpenFilter: Subject<any>;
   acoesService: AcoesService;

   refreshGrid: Subscription;
   dataSourceEvent: Subscription;
   dynamicFilterEvent: Subscription;
   dynamicFilterReadyEvent: Subscription;

   @Output() preparedRow: EventEmitter<any> = new EventEmitter();
   @Output() selectionChangedAction: EventEmitter<any> = new EventEmitter();

   stateStoringEnabled: boolean = false;

   currentGridState: any;

   context: any;
   filtro: any;
   window: any;
   filterState: string = 'normal';
   firstRun: boolean = true;

   @Output() openFilter: EventEmitter<any> = new EventEmitter();
   filterClass: string = 'normal';

   @Output() stateChanged: EventEmitter<any> = new EventEmitter();

   constructor(
      protected _appService: KmmNgBackendService,
      protected _cd: ChangeDetectorRef,
      protected _factoryResolver: ComponentFactoryResolver,
      protected _injector: Injector,
      protected _messageService: MessageService,
      protected _navigationService: NavigationService,
      protected _gridService: GridService,
      protected _presenterService: PresenterService,
      protected _sanitizer: DomSanitizer
   ) {
   }

   ngOnInit() {
      try {
         this.contextName = this.dataSource.contextName;

         this.refreshGrid = this._gridService.refreshGrid.subscribe((refresh) => {
            this.currentGridState = this.dxDataGrid.instance.state();

            if (refresh) {
               this.loadSource(false);
            }
         });

         this._gridService.gridContext[this.contextName] = this;

         this.createCustomComponents();

         this.dynamicFilterEvent = this.dynamicFilter.filterEvent.subscribe(submitData => {
            if (this._gridService.dynamicFilterParams) {
               Object.assign(submitData.params, this._gridService.dynamicFilterParams);
            }

            Object.assign(this.dataSource, {
               module: submitData.submit.module, operation: submitData.submit.operation, params: submitData.params
            });
            this._gridService.callRefresh();
            this.dynamicFilter.visible = false;

            if (!submitData.reset) {
               this.filterState = 'default';
            } else {
               if (this.dynamicFilter.hasDefault) {
                  this.filterState = 'default';
               } else {
                  this.filterState = 'normal';
               }
            }

            this.dynamicFilter.resetParams = false;

            this.dxDataGrid.instance.repaint();
         });

         this.dynamicFilterReadyEvent = this.dynamicFilter.filterReady.subscribe(data => {
            if (this._gridService.dynamicFilterParams) {
               Object.assign(this.dynamicFilter.dataModel, this._gridService.dynamicFilterParams);
            }

            Object.assign(this.dataSource, {
               module: this.filtro.submit.module, operation: this.filtro.submit.operation, params: this.dynamicFilter.dataModel
            });
            this._gridService.callRefresh();

            this.filterState = 'default';
            this.dxDataGrid.instance.repaint();
         });
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 159', ex, 5000);
      }
   }

   ngAfterViewInit() {
      try {
         if (this.dataSource.filter) {
            this._appService.backendCall(this.dataSource.filter.module, this.dataSource.filter.operation, null).subscribe(filter => {
               this.filtro = filter.filtro;

               if (filter) {
                  this.dynamicFilter.setItems(filter.filtro);

                  this.firstRun = false;
               } else {
                  this.loadSource();
               }
            });
         } else {
            this.loadSource();
         }
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 167', ex, 5000);
      }
      this._cd.detectChanges();
   }

   ngAfterContentInit() {
      try {
         if (this.gridTemplate) {
            this.gridTemplate.templates.forEach(item => {
               this.cCols.push(item);
            });
         }
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 180', ex, 5000);
      }
   }

   preventKeyboard(ev) {
      // ev.event.preventDefault();
   }

   getState(changeSource: boolean = true) {
      try {
         this._gridService.getModelos({ grid_ref: this.contextName, padrao: true }).subscribe(data => {
            if (changeSource) {
               if (data.length > 0) {
                  const state = JSON.parse(data[0].colunas);

                  this.currentGridState = state;

                  this.dxDataGrid.instance.state(this.currentGridState);
               } else {
                  this.currentGridState = this.dxDataGrid.instance.state();

                  this.stateStoringEnabled = true;
               }
            } else {
               this.dxDataGrid.instance.state(this.currentGridState);
            }

            this.stateChanged.emit();
         });
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 210', ex, 5000);
      }
   }

   loadSource(changeState: boolean = true) {
      try {
         if (this.dataSource.module && this.dataSource.operation) {
            let modulo = '';

            if (this._appService.modules[this.dataSource.module]) {
               modulo = this._appService.modules[this.dataSource.module];
            } else {
               modulo = this.dataSource.module;
            }

            if (this.firstRun) {
               if (this.dataSource.params) {
                  Object.assign(this.dataSource.params, {
                     nodata: true
                  });
               }
            } else {
               if (this.dataSource.params) {
                  delete this.dataSource.params.nodata;
               }
            }

            this._appService.backendCall(modulo, this.dataSource.operation, this.dataSource.params, null, { gridCols: true })
               .subscribe(data => {
                  if (data['root'].header.summaries) {
                     this.summaryItems = data['root'].header.summaries.total_item;
                     this.summaries = data['root'].header.summaries.group_item;
                  }

                  this.filtro = data['root'].header.filtro;
                  this.window = data['root'].header.window;
                  this.processResult(data, changeState);
               });
         } else if (this.dataSource.service) {
            this.dataSource.service.function.call(this.dataSource.service.context, this.dataSource.params, { gridCols: true })
               .subscribe(data => {
                  if (data['root'].header.summaries) {
                     this.summaryItems = data['root'].header.summaries.total_item;
                     this.summaries = data['root'].header.summaries.group_item;
                  }
                  this.filtro = data['root'].header.filtro;
                  this.window = data['root'].header.window;
                  this.processResult(data, changeState);
               });
         }
      } catch (ex) {
         console.log(ex);
         this._messageService.notify(ex + ' - LoadSource', 'error', 'dynamic-grid.component 230', ex, 5000);
      }
   }

   processResult(results: any, changeState: boolean) {
      try {
         const cols = results['cols'];

         const columns = cols.concat(this.customColumns);

         if (this.dataSource.calculateCellValues) {
            this.dataSource.calculateCellValues.forEach(cellValue => {
               columns.forEach(column => {
                  if (column.dataField === cellValue.dataField) {
                     Object.assign(column, {
                        calculateCellValue: cellValue.calculate
                     });
                  }
               });
            });
         }

         if (this.dataSource.calculateDisplayValues) {
            this.dataSource.calculateDisplayValues.forEach(displayValue => {
               columns.forEach(column => {
                  if (column.dataField === displayValue.dataField) {
                     Object.assign(column, {
                        calculateDisplayValue: displayValue.calculate
                     });
                  }
               });
            });
         }

         if (this.dataSource.calculateSortValues) {
            this.dataSource.calculateSortValues.forEach(sortValue => {
               columns.forEach(column => {
                  if (column.dataField === sortValue.dataField) {
                     Object.assign(column, {
                        calculateSortValue: sortValue.calculate
                     });
                  }
               });
            });
         }

         if (this.dataSource.calculateGroupValues) {
            this.dataSource.calculateGroupValues.forEach(groupValue => {
               columns.forEach(column => {
                  if (column.dataField === groupValue.dataField) {
                     Object.assign(column, {
                        calculateGroupValue: groupValue.calculate
                     });
                  }
               });
            });
         }

         cols.forEach(col => {
            this.gridColumns.forEach(column => {
               if (col.dataField === column.dataField) {
                  Object.assign(col, column);
               }
            });
         });

         this.columns = columns;

         // Reprocessa formato de datas para IE
         results['data'] = results['data'].map(row => {
            const keys = Object.keys(row);

            keys.forEach(item => {
               if (isNaN(row[item]) && typeof row[item] !== 'object') {
                  if (row[item].match(/^(\d{4})\-(\d{2})\-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/)) {
                     Object.assign(row, {
                        [item]: new Date(row[item].replace(' ', 'T'))
                     });
                  }
               }
            });

            return row;
         });

         this.dxDataGrid.instance.option('dataSource', results['data']);
         this.getState(changeState);

         if (this.firstRun) {
            this.firstRun = false;

            if (this.filtro) {
               this.dynamicFilter.setItems(this.filtro);
            }
         }

      } catch (ex) {
         console.log(ex);
         // this._messageService.notify(ex + ' - ProcessResult', 'error', 'dynamic-grid.component 301', ex, 5000);
      }
   }

   addCustom(cellTemplate: string, component: any, options: Object = {}) {
      try {
         const factory = this._factoryResolver.resolveComponentFactory(component);
         this.factory.push(factory);

         const componentRef = this.customComponentsContainer.createComponent(factory);
         this.componentRef.push(componentRef);

         const componentInstance = componentRef.instance;

         Object.assign(componentInstance, {
            context: this,
            templateName: cellTemplate
         });

         this.componentInstance.push(componentInstance);
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 322', ex, 5000);
      }
   }

   createCustomComponents() {
      try {
         console.log(this._injector);
         // if (this._gridService.gridContext[this.contextName].customColumns) {
         //    this._gridService.gridContext[this.contextName].customColumns.forEach((item, templateIndex) => {
         if (this.customColumns) {
            this.customColumns.forEach((item, templateIndex) => {
               if (item['cellTemplate']) {
                  const factory = this._factoryResolver.resolveComponentFactory(item['component']);
                  this.factory.push(factory);

                  const componentRef = this.customComponentsContainer.createComponent(factory);
                  this.componentRef.push(componentRef);

                  const componentInstance = componentRef.instance;

                  Object.assign(componentInstance, {
                     context: this,
                     cellTemplate: item['cellTemplate'],
                     templateName: item['cellTemplate']
                  });

                  Object.assign(componentInstance, item['editorOptions']);

                  this.componentInstance.push(componentInstance);
               }
            });
         }

         if (this._gridService.gridContext[this.contextName].masterDetails) {
            this._gridService.gridContext[this.contextName].masterDetails.forEach((item, templateIndex) => {
               if (item['template']) {
                  const factory = this._factoryResolver.resolveComponentFactory(item['component']);
                  this.factory.push(factory);

                  const componentRef = this.customComponentsContainer.createComponent(factory);
                  this.componentRef.push(componentRef);

                  const componentInstance = componentRef.instance;

                  Object.assign(componentInstance, {
                     context: this,
                     templateName: item['template']
                  });

                  this.componentInstance.push(componentInstance);
               }
            });
         }
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 373', ex, 5000);
      }

   }

   createPopupComponents() {
      try {
         if (this.popupComponents) {
            this.popupComponents.forEach((item, index) => {
               if (item.render) {
                  this.popupFactory.push(this._factoryResolver.resolveComponentFactory(item.component));
               }
            });

            this.popupFactory.forEach((item, index) => {
               this.popupComponentRef.push(this.popupsContainer.createComponent(item));
            });

            this.popupComponentRef.forEach((item, index) => {
               this.popupComponentInstance.push(item.instance);
            });

            this.popupComponentInstance.forEach((item, index) => {
               item.context = this.popupComponents[index].context;
            });
         }
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 400', ex, 5000);
      }

   }

   showForm() {
      try {
         this.popupComponents.forEach((item, index) => {
            if (item.form) {
               const factory = this._factoryResolver.resolveComponentFactory(item.component);
               const ref = this.popupsContainer.createComponent(factory);

               Object.assign(ref.instance, item.context);

               ref.instance['popupFormVisible'] = true;
            }
         });
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 418', ex, 5000);
      }
   }

   isDisabled(evento: string): boolean {
      return true;
   }

   showInsert() {
      return true;
   }

   onExporting(event) {
      notify({
         message: 'O download foi iniciado',
         type: 'info',
         displayTime: 3000,
         closeOnClick: true,
         width: function () { return window.innerWidth / 1.8; }
      });
   }

   onExported(event) {
      notify({
         message: 'O download foi concluÃ­do com sucesso',
         type: 'success',
         displayTime: 3000,
         closeOnClick: true,
         width: function () { return window.innerWidth / 1.8; }
      });
   }

   onToolbarPreparing(event) {
      try {
         const toolbarItems = event.toolbarOptions.items;

         toolbarItems.forEach(function (item) {
            if (item.name === 'searchPanel') {
               item.location = 'after';
            }
         });

         const defaultItems = [
            {
               location: 'after',
               widget: 'dxButton',
               options: {
                  icon: 'collapse',
                  hint: 'Retrair todos',
                  elementAttr: {
                     id: 'collapse'
                  },
                  onClick: () => this.collapseAll()
               }
            },
            {
               location: 'after',
               widget: 'dxButton',
               options: {
                  icon: 'expand',
                  hint: 'Mostrar todos',
                  elementAttr: {
                     id: 'expand'
                  },
                  onClick: () => this.expandAll()
               }
            },
            {
               location: 'after',
               widget: 'dxButton',
               options: {
                  icon: 'refresh',
                  hint: 'Atualizar',
                  elementAttr: {
                     id: 'atualizar'
                  },
                  onClick: () => this._gridService.callRefresh()
               }
            },
            {
               location: 'after',
               widget: 'dxButton',
               options: {
                  icon: 'fas fa-table',
                  hint: 'Modelo',
                  elementAttr: {
                     id: 'modelo'
                  },
                  onClick: () => this.toggleModeloPopup()
               }
            },
            {
               location: 'after',
               widget: 'dxButton',
               options: {
                  icon: 'filter',
                  hint: 'Filtro',
                  type: this.filterState,
                  onClick: () => this.openFiltro()
               }
            }
         ];

         let items;

         if (this.toolbar) {
            items = defaultItems.concat(this.toolbar);
         } else {
            items = defaultItems;
         }

         items.forEach(item => {
            toolbarItems.push(item);
         });
      } catch (ex) {
         this._messageService.notify(ex, 'error', 'dynamic-grid.component 523', ex, 5000);
      }

   }

   collapseAll() {
      this.dxDataGrid.instance.collapseAll();
   }

   expandAll() {
      this.dxDataGrid.instance.expandAll();
   }

   toggleModeloPopup(showForm: boolean = false) {
      this.modeloGridLista.visible = true;
      this.modeloGridLista.modeloGridForm.visible = showForm;
   }

   onRowPrepared(e) {
      this.preparedRow.emit(e);
   }

   ngOnDestroy() {
      if (!!this.refreshGrid) {
         this.refreshGrid.unsubscribe();
      }

      if (!!this.dynamicFilterEvent) {
         this.dynamicFilterEvent.unsubscribe();
      }

      if (!!this.dynamicFilterReadyEvent) {
         this.dynamicFilterReadyEvent.unsubscribe();
      }

      this.dynamicFilter.dataModel = {};
      this.dynamicFilter.firstRun = true;
      this.firstRun = true;
   }

   onSelectionChanged(ev) {
      this.selectionChangedAction.emit(ev);
   }

   @Input()
   set toolbar(toolbar: any) {
      this._toolbar = toolbar;
   }

   get toolbar(): any {
      return this._toolbar;
   }

   customizeExportData(columns, rows) {
      rows.forEach(row => {
         const rowValues = row.values;

         for (let i = 0; i < rowValues.length; i++) {
            if (typeof rowValues[i] === 'string') {
               // Eliminar tags HTML de strings
               const plainText = rowValues[i].replace(/<[^>]*>/g, '');

               rowValues[i] = plainText;
            }

         }
      });
   }

   openFiltro() {
      if (this.filtro) {
         this.dynamicFilter.setItems(this.filtro);
         this.dynamicFilter.visible = true;
      }
   }

}
